export const uploadName = 'upload'
export const uploadFieldsSchemaPath = 'upload.fields'
